const HAS_SCHEME = /^[a-zA-Z][a-zA-Z0-9+.-]*:/
const IPV4 = /^(\d{1,3}\.){3}\d{1,3}$/
const HOSTNAME_WITH_TLD = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i

function isPlausibleHostname(hostname) {
  if (!hostname) return false
  if (hostname === 'localhost') return true

  if (IPV4.test(hostname)) {
    return hostname.split('.').every((octet) => {
      const n = Number(octet)
      return n >= 0 && n <= 255
    })
  }

  return HOSTNAME_WITH_TLD.test(hostname)
}

/**
 * Turn a user-typed website into an absolute http(s) URL.
 * Bare hostnames get https://. Explicit http:// is left as http.
 *
 * @param {string} input
 * @returns {{ ok: true, url: string } | { ok: false, error: string }}
 */
export function normalizeWebsiteUrl(input) {
  const trimmed = typeof input === 'string' ? input.trim() : ''
  if (!trimmed) {
    return { ok: false, error: 'Please enter a URL' }
  }

  let candidate = trimmed
  if (candidate.startsWith('//')) {
    candidate = `https:${candidate}`
  } else if (!HAS_SCHEME.test(candidate)) {
    candidate = `https://${candidate}`
  }

  let parsed
  try {
    parsed = new URL(candidate)
  } catch {
    return { ok: false, error: 'Please enter a valid URL (e.g., https://example.com)' }
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return { ok: false, error: 'Please enter a valid URL (e.g., https://example.com)' }
  }

  if (!isPlausibleHostname(parsed.hostname)) {
    return { ok: false, error: 'Please enter a valid URL (e.g., https://example.com)' }
  }

  return { ok: true, url: parsed.toString() }
}

/**
 * Dashboard prefill from a free-scan signup link. Only http(s) URLs stick.
 * @param {string} search
 * @returns {string}
 */
export function prefillUrlFromSearch(search) {
  const raw = new URLSearchParams(search || '').get('url')
  if (!raw) return ''
  const normalized = normalizeWebsiteUrl(raw)
  return normalized.ok ? normalized.url : ''
}
